import { useEditDocumentContext } from 'shared/hooks/use-edit-document';
import { FormikContextType } from 'formik';
import { TDocFile } from 'shared/constants/docs';
import { FormTextField } from 'shared/_ui/form/form-text-field';
import { CardFieldsContainer } from 'shared/_ui/layout';

export default function FileNotes({ formik }: { formik: FormikContextType<TDocFile> }) {
	const { isEdit } = useEditDocumentContext();

	return (
		<CardFieldsContainer sx={{ minHeight: '15rem' }}>
			<FormTextField
				label="Notes:"
				name="notes"
				fullWidth
				formik={formik}
				labelProps={{ width: '4.75rem' }}
				multiline
				placeholder="Add notes about your file"
				spellCheck
				readOnly={!isEdit}
				// onReadOnlyClick={handleEnableEdit}
				// sx={fieldSx}
			/>
		</CardFieldsContainer>
	);
}
